export default function PaymentMethods() {
  const paymentMethods = [
    {
      name: "Банковские карты",
      icon: "ri-bank-card-line",
      casinos: ["Fugu", "SOL", "FRESH", "LEX", "MONRO", "IZZI", "STARDA", "1GO"],
      minDeposit: "500 ₽",
      withdrawTime: "1-3 часа",
      commission: "0%"
    },
    {
      name: "Электронные кошельки",
      icon: "ri-wallet-3-line",
      casinos: ["SOL", "FRESH", "LEX", "IZZI", "1GO", "LEGZO", "ROX"],
      minDeposit: "300 ₽",
      withdrawTime: "Мгновенно",
      commission: "0%"
    },
    {
      name: "Криптовалюта",
      icon: "ri-bit-coin-line",
      casinos: ["Fugu", "DRIP", "GIZBO", "IRWIN", "Flagman"],
      minDeposit: "1000 ₽",
      withdrawTime: "30 минут",
      commission: "0%"
    },
    {
      name: "Мобильные платежи",
      icon: "ri-smartphone-line",
      casinos: ["MONRO", "STARDA", "VOLNA", "LEGZO"],
      minDeposit: "500 ₽",
      withdrawTime: "2-4 часа",
      commission: "0-2%"
    }
  ];

  const providers = [
    {
      name: "Pragmatic Play",
      games: 250,
      popular: ["Sweet Bonanza", "Gates of Olympus", "Sugar Rush"],
      rtp: "96.5%",
      bonus: "Отлично для отыгрыша"
    },
    {
      name: "NetEnt",
      games: 180,
      popular: ["Starburst", "Gonzo's Quest", "Dead or Alive"],
      rtp: "96.2%",
      bonus: "Высокая отдача"
    },
    {
      name: "Play'n GO",
      games: 200,
      popular: ["Book of Dead", "Reactoonz", "Fire Joker"],
      rtp: "96.3%",
      bonus: "Популярны в бонусах"
    },
    {
      name: "Evolution Gaming",
      games: 120,
      popular: ["Lightning Roulette", "Crazy Time", "Monopoly Live"],
      rtp: "97.3%",
      bonus: "Live-казино"
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white animate-on-scroll opacity-0">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Методы оплаты для отыгрыша бонусов в казино онлайн
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Выбирайте удобный способ пополнения и быстрого вывода выигрышей
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-16">
          {paymentMethods.map((method, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-8 border border-gray-100 hover:scale-105"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl flex items-center justify-center">
                  <i className={`${method.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">{method.name}</h3>
              </div>

              <div className="grid grid-cols-3 gap-4 mb-6">
                <div>
                  <div className="text-xs text-gray-500 mb-1">Мин. депозит</div>
                  <div className="font-bold text-gray-900">{method.minDeposit}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">Вывод</div>
                  <div className="font-bold text-gray-900">{method.withdrawTime}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">Комиссия</div>
                  <div className="font-bold text-green-600">{method.commission}</div>
                </div>
              </div>

              <div>
                <div className="text-sm font-semibold text-gray-700 mb-3">Доступно в казино онлайн:</div>
                <div className="flex flex-wrap gap-2">
                  {method.casinos.map((casino, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-sm font-medium"
                    >
                      {casino}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mb-16">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Провайдеры игр для отыгрыша бонусов в казино онлайн
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {providers.map((provider, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6 border border-gray-100 hover:scale-105"
              >
                <h4 className="text-xl font-bold text-gray-900 mb-3">{provider.name}</h4>
                <div className="flex items-center justify-between mb-4">
                  <span className="text-sm text-gray-600">Игр:</span>
                  <span className="font-bold text-orange-600">{provider.games}+</span>
                </div>
                <div className="flex items-center justify-between mb-4">
                  <span className="text-sm text-gray-600">RTP:</span>
                  <span className="font-bold text-green-600">{provider.rtp}</span>
                </div>
                <div className="mb-4">
                  <div className="text-xs text-gray-500 mb-2">Популярные игры:</div>
                  <div className="space-y-1">
                    {provider.popular.map((game, idx) => (
                      <div key={idx} className="text-sm text-gray-700">• {game}</div>
                    ))}
                  </div>
                </div>
                <div className="pt-4 border-t border-gray-100">
                  <div className="inline-block bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-semibold">
                    {provider.bonus}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gradient-to-r from-orange-50 to-yellow-50 rounded-2xl p-8 border border-orange-100">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Ловушки бонусов: на что обратить внимание
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white rounded-xl p-6">
              <div className="flex items-start gap-3 mb-3">
                <i className="ri-alert-line text-2xl text-red-500 mt-1"></i>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Ограничения по ставкам</h4>
                  <p className="text-sm text-gray-600">
                    Максимальная ставка при отыгрыше обычно 50-100 ₽. Превышение приведет к аннулированию бонуса.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6">
              <div className="flex items-start gap-3 mb-3">
                <i className="ri-alert-line text-2xl text-red-500 mt-1"></i>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Игры с низким вкладом</h4>
                  <p className="text-sm text-gray-600">
                    Настольные игры часто засчитываются только на 10-20%. Проверяйте условия перед игрой.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6">
              <div className="flex items-start gap-3 mb-3">
                <i className="ri-alert-line text-2xl text-red-500 mt-1"></i>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Срок действия бонуса</h4>
                  <p className="text-sm text-gray-600">
                    Обычно 7-30 дней. Не успели отыграть — бонус сгорает вместе с выигрышами.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6">
              <div className="flex items-start gap-3 mb-3">
                <i className="ri-alert-line text-2xl text-red-500 mt-1"></i>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Лимит на вывод</h4>
                  <p className="text-sm text-gray-600">
                    С бездепозитных бонусов часто можно вывести максимум 3-5 тысяч рублей.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}